var render, staticRenderFns
import script from "./animation-reward-spin.vue?vue&type=script&lang=js"
export * from "./animation-reward-spin.vue?vue&type=script&lang=js"
import style0 from "./animation-reward-spin.vue?vue&type=style&index=0&id=d6af388c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports